/**
 * Maps Portunus /pub/{id_public} JSON to UI fields. Only uses fields present on the payload.
 * Requires mainDevice (primary asset). No synthetic defaults.
 * @param {Record<string, unknown>} payload
 */
export function mapPubResponseToViewModel(payload) {
  if (!payload || typeof payload !== 'object') return null;
  if (payload.ok === false) return null;

  if (!payload.mainDevice || typeof payload.mainDevice !== 'object') return null;

  const md = payload.mainDevice;
  const cert =
    payload.certificate && typeof payload.certificate === 'object'
      ? payload.certificate
      : null;

  const components = Array.isArray(payload.components) ? payload.components : [];
  const mainItemId = md.itemId;

  const sr =
    payload.serviceRequest && typeof payload.serviceRequest === 'object'
      ? payload.serviceRequest
      : null;

  const heading = cert?.title ?? cert?.activityType ?? null;

  let certificateId = null;
  if (payload.certificateNumber != null && payload.certificateNumber !== '') {
    certificateId = String(payload.certificateNumber);
  } else if (payload.activityId != null) {
    certificateId = String(payload.activityId);
  }

  const description =
    typeof md.description === 'string' && md.description.trim() !== ''
      ? md.description.trim()
      : null;

  const categoryLabel =
    typeof md.componentCategoryName === 'string' && md.componentCategoryName.trim() !== ''
      ? md.componentCategoryName.trim()
      : null;

  const extraComponents = components.filter((c) => {
    if (!c) return false;
    if (mainItemId != null && c.itemId != null && c.itemId === mainItemId) return false;
    return true;
  });

  return {
    heading,
    certificateId,
    productName: md.productName != null ? String(md.productName) : null,
    productCode: md.productCode != null ? String(md.productCode) : null,
    serialNumber: md.serialNumber != null ? String(md.serialNumber) : null,
    categoryLabel,
    status: cert?.stateName != null ? String(cert.stateName) : null,
    // certificate.validTo / certificate.issuedAt (PM due vs last service)
    nextPmDate: formatIsoDate(cert?.validTo),
    lastServiced: formatIsoDate(cert?.issuedAt),
    description,
    extraComponents,
    requestServiceEnabled: sr?.enabled === true,
  };
}

function formatIsoDate(value) {
  if (value == null || value === '') return null;
  const d = new Date(typeof value === 'string' ? value : String(value));
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function getImageDocuments(payload) {
  if (!payload || !Array.isArray(payload.documents)) return [];
  return payload.documents.filter(
    (doc) =>
      doc &&
      typeof doc.mimeType === 'string' &&
      doc.mimeType.toLowerCase().startsWith('image/')
  );
}
